<template>
  <div class="modal-card">
    <CloseIcon :size="24" class="close-modal-icon close-on-click" />
    <div class="modal-card-header">
      <h1 class="title">Cancel Ticket</h1>
      <p class="subtitle">This will permanently mark the ticket as cancelled. Any remaining balance on its receivables will be written off, and no further payments can be collected. Payments already made will not be affected.</p>
    </div>
    <div class="modal-card-body">
      <div v-if="error" class="modal-error">
        {{ error }}
      </div>
    </div>
    <div class="modal-card-footer">
      <button class="button form-button" @click="handleClose">
        Keep Ticket
      </button>
      <button class="button danger form-button" @click="handleConfirm" :disabled="isSubmitting">
        {{ isSubmitting ? 'Cancelling...' : 'Cancel Ticket' }}
      </button>
    </div>
  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import * as api from '@/api';

export default {
  name: "CancelTicketModal",
  props: {
    ticketId: {
      type: [Number, String],
      required: true
    }
  },
  emits: ['close', 'cancelled'],
  data() {
    return {
      isSubmitting: false,
      error: null
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    async handleConfirm() {
      this.error = null;
      this.isSubmitting = true;

      try {
        await api.cancelTicket(this.ticketId);
        this.$emit('cancelled');
      } catch (err) {
        this.error = err.message || 'Failed to cancel ticket';
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  components: { CloseIcon }
};
</script>

<style scoped>
.modal-card {
  max-width: 450px;
}

.title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 8px 0 0 0;
}

.modal-card-body {
  margin-top: 20px;
}

.button.danger {
  background-color: #dc2626;
  color: #fff;
  border-color: #dc2626;
  box-shadow: 0 2px 0px #991b1b;
}

.button.danger:hover {
  background-color: #b91c1c;
  border-color: #b91c1c;
}

.button.danger:active {
  background-color: #991b1b;
  border-color: #991b1b;
}

.button.danger:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  border-color: #d1d5db;
  box-shadow: none;
}
</style>
